import { readCookies } from './cookie-parser-util';

export const GA_CLIENT_ID_COOKIE_NAME = '_ga';

export function parseGaClientIdCookie(headers: Headers): string {
  return (
    readCookies<{ gaClientId?: string }>(headers, {
      gaClientId: { name: GA_CLIENT_ID_COOKIE_NAME, parse: raw => raw.substring(6) },
    }).gaClientId ?? ''
  );
}
